import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import { MapV2GlassEffectBackground } from 'components/mapV2/elements/MapV2GlassEffectBackground';
import { MapV2ModalLayoutPc } from 'components/mapV2/MapV2Modal/layout/generic/MapV2ModalLayoutPc';
import { MapV2ModalDetail } from 'components/mapV2/MapV2Modal/MapV2ModalDetail';
import { MapV2ModalList } from 'components/mapV2/MapV2Modal/MapV2ModalList';
import { AnimatePresence, motion } from 'framer-motion';
import { FFullMoment } from 'graphql/fragment/__generated__/FFullMoment';
import { WorldMapMarkerStory_worldMapView_markers } from 'graphql/query/__generated__/WorldMapMarkerStory';
import { useContext, useState } from 'react';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    storiesList: FFullMoment[];
    marker: WorldMapMarkerStory_worldMapView_markers | null;
}

export const MapV2WithoutListPc = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const ctxMapV2 = useContext(CtxMapV2);
    const isWide = ctxMapV2.isWide;

    const [height, setHeight] = useState<string>('0px');

    if (!ctxModal.detailListModal && !ctxModal.detailModal?.detail) {
        return null;
    }

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={'modal'}
                style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1000
                }}
                initial={{
                    marginRight: -400
                }}
                animate={{
                    marginRight: 0
                }}
                exit={{
                    marginRight: -400
                }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
            >
                <MapV2ModalLayoutPc
                    onHeightChanged={(height) => {
                        setHeight(height);
                    }}
                >
                    {isWide && <MapV2GlassEffectBackground color="rgba(246, 247, 245, 0.7)" />}
                    {ctxModal.detailListModal && !ctxModal.detailModal?.detail && (
                        <S_MapV2ModalList
                            stories={props.storiesList}
                            height={height}
                            withoutHeader
                        />
                    )}
                    {ctxModal.detailModal?.detail && (
                        <S_MapV2ModalDetail
                            story={ctxModal.detailModal.detail}
                            marker={props.marker}
                            height={height}
                        />
                    )}
                </MapV2ModalLayoutPc>
            </motion.div>
        </AnimatePresence>
    );
};

const S_MapV2ModalDetail = styled(MapV2ModalDetail)`
    width: 375px;
`;

const S_MapV2ModalList = styled(MapV2ModalList)`
    width: 375px;
`;
